import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { applySeo } from "@/lib/seo";

export default function Datenschutz() {
  useEffect(() => {
    applySeo({
      title: "Datenschutz – Grüne Geldanlage",
      description: "Datenschutzerklärung von Grüne Geldanlage: Verantwortlicher, Cookies, Rechte der Betroffenen – DSGVO-konforme Vorlage.",
      canonicalPath: "/datenschutz",
    });
  }, []);
  return (
    <div className="min-h-screen bg-brand-paper" data-testid="datenschutz-page">
      <Header />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-20 pb-24">
        <div className="overline mb-4">Rechtliches</div>
        <h1 className="font-serif text-5xl font-light leading-tight text-brand-dark mb-10">Datenschutzerklärung</h1>
        <div className="prose-editorial max-w-none">
          <h2>1. Verantwortlicher</h2>
          <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist die im Impressum genannte Redaktion Grüne Geldanlage.</p>
          <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
          <p>Bei jedem Aufruf unserer Website erfasst unser Server automatisch Informationen (Server-Logfiles) wie IP-Adresse, Browsertyp, Zugriffszeitpunkt, aufgerufene Ressource und Referrer. Diese Daten werden aus Sicherheits- und Betriebsgründen für maximal 14 Tage gespeichert und anschließend gelöscht.</p>
          <h2>3. Cookies</h2>
          <p>Wir verwenden ausschließlich technisch notwendige Cookies (z. B. Session-Cookie für den Admin-Login). Weitere Details finden Sie in unseren <a href="/cookie-richtlinien">Cookie-Richtlinien</a>.</p>
          <h2>4. Analyse und Tracking</h2>
          <p>Wir setzen keine Tools zur reichweitenübergreifenden Nachverfolgung ein. Sollte sich das ändern (z. B. datenschutzfreundliche Web-Analytics), aktualisieren wir diese Erklärung entsprechend und holen – wo erforderlich – Ihre Einwilligung ein.</p>
          <h2>5. Kontaktaufnahme</h2>
          <p>Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben ausschließlich zur Bearbeitung der Anfrage gespeichert und nach Erledigung gelöscht, sofern keine gesetzliche Aufbewahrungspflicht besteht.</p>
          <h2>6. Rechte der Betroffenen</h2>
          <p>Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21). Wenden Sie sich hierzu an die im Impressum genannten Kontaktdaten. Beschwerderecht bei der zuständigen Aufsichtsbehörde nach Art. 77 DSGVO.</p>
          <h2>7. Hosting</h2>
          <p>Die Website wird bei einem europäischen Anbieter gehostet. Auftragsverarbeitungsverträge nach Art. 28 DSGVO liegen vor.</p>
          <p className="text-sm text-neutral-500">Diese Datenschutzerklärung ist eine Vorlage und muss durch einen Juristen an die tatsächlichen Datenverarbeitungsprozesse angepasst werden.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
